import React from "react";
import Modal from "./base/Modal";
import PublishPanel from "./PublishPanel";
import styles from "./PublishPanelModal.module.css";

function PublishPanelModal(props) {
  return (
    <Modal {...props}>
      <Modal.Dialog contentClassName={styles["publish-dialog"]}>
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>Publish Your Site</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body className={styles["publish-dialog-body"]}>
          <PublishPanel />
        </Modal.Dialog.Body>
      </Modal.Dialog>
    </Modal>
  );
}

export default PublishPanelModal;
